import { defineStore } from "pinia"
import { useApiCallStore } from "src/stores/apiCallStore"
import { HttpAbortConfig, HttpRequestType } from "src/util/types/dataModels/http"
import { v4 as uuidv4 } from "uuid"

export interface ApiAbortStoreType {
  abortControllerData: HttpAbortConfig[]
}

export const useApiAbortStore = defineStore("pinia-apiAbortStore", {
  state: (): ApiAbortStoreType => ({
    abortControllerData: [],
  }),

  actions: {
    createController(requestType: HttpRequestType, url?: string): HttpAbortConfig {
      const abortController = new AbortController()
      const id = uuidv4()

      const httpConfig: HttpAbortConfig = { controller: abortController, id, requestType, url }

      this.addController(httpConfig)

      return httpConfig
    },

    addController(abortHandler: HttpAbortConfig) {
      const apiCallStore = useApiCallStore()
      abortHandler.url = apiCallStore.getFixedUrl(abortHandler.url || "")
      this.abortControllerData.push(abortHandler)
    },

    removeController(id: string) {
      this.abortControllerData = this.abortControllerData.filter((i) => i.id !== id)
    },

    abortControllers(requestType: HttpRequestType = "GET") {
      const apiCallStore = useApiCallStore()
      for (const controllerData of this.abortControllerData) {
        if (controllerData.requestType === requestType) {
          controllerData.controller.abort()
          if (controllerData.url) apiCallStore.endpointLastCall[controllerData.url] = 0
          this.removeController(controllerData.id)
        }
      }
    },
  },
})
